import {React, useState} from 'react';
import {Link} from 'react-router-dom';
import {Grid, Box, Button, Paper, createTheme, ThemeProvider, Typography} from '@mui/material';
import {Badge, PriceChange} from '@mui/icons-material';

function handleClick(event){
  alert(event.currentTarget.id)
}

function CompanyMasters(){

  const [values, setValues] = useState();
  const [openPopup, setOpenPopup] = useState(false);

  const theme = createTheme({
    palette: {
      primary: { main: '#0b418e' },
      danger: {
        main: '#ffeb3b',
      },
      orange: {
        main: '#ff5722',
      },
      blueGrey: {
        main: '#607d8b',
      },
      lightGreen: {
        main: '#689f38',
      },
      pink: {
        main: '#ec407a',
      },
      purple: {
        main: '#ab47bc',
      },
      deepPurple: {
          main: '#7e57c2',
      },
      amber: {
        main: '#ffca28'
      },
      lime: {
        main: '#c0ca33'
      },
      brown: {
        main: '#8d6e63'
      }
    },
  });

  return(
    <ThemeProvider theme={theme}>
    <Box className="master-button-container">
      <Paper className="paper-container" elevation={5} sx={{width: "1000px", padding: "30px"}}>
      <Typography variant="h4" sx={{textAlign: "center", marginBottom: "20px"}}>Masters</Typography>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
                <Link to="view-employees" className="link">
                  <Button id="btn1" sx={{color: "white"}} className="master-btn" variant="contained" color="deepPurple" startIcon={<Badge sx={{width: "30px", height: "30px"}}/>}>
                    Employee Master
                  </Button>
                </Link>
            </Grid>
            <Grid item>
              <Link to="earning-and-deduction-master" className="link">
                <Button id="btn2" sx={{color: "white"}} className="master-btn" variant="contained" color="success" startIcon={<PriceChange sx={{width: "30px", height: "30px"}}/>}>
                  Earning & Deduction Master
                </Button>
              </Link>
            </Grid>
          </Grid>



      </Paper>
    </Box>
    </ThemeProvider>
  )
}

export default CompanyMasters;
